export default __webpack_public_path__ + "static/media/wealth_raffle_turn_icon1.69dae313.png";